/**
 * HanziTTS
 * "Pre-Rolled" Engine - Wakes up the hardware BEFORE speaking the character.
 */
class HanziTTS {
    constructor() {
        this.synth = window.speechSynthesis;
        this.activeUtterance = null;
    }

    unlock() {
        if (!this.synth) return;
        console.log('[TTS] Hardware Wake-up...');
        this.synth.cancel();
        this.synth.resume();

        // Silent bit to prime the stream
        const ghost = new SpeechSynthesisUtterance(' ');
        ghost.volume = 0;
        this.synth.speak(ghost);
    }

    speak(text, onStart, onEnd) {
        if (!this.synth) return;

        // Aggressive reset
        this.synth.cancel();
        this.synth.resume();

        // 1. Prepend a tiny pause to the text to "prime" the audio device
        // Some OS engines clip the first 100ms of a speech utterance.
        const cleanText = text.trim();
        console.log(`[TTS] -> PREPARING: "${cleanText}"`);

        const utterance = new SpeechSynthesisUtterance(cleanText);
        this.activeUtterance = utterance;

        utterance.lang = 'zh-CN';
        utterance.rate = 0.75; // Slightly slower to ensure clarity
        utterance.volume = 1.0;
        utterance.pitch = 1.0;

        const voices = this.synth.getVoices();
        const voice = voices.find(v => v.name === 'Tingting') ||
            voices.find(v => v.name.includes('Google Mandarin')) ||
            voices.find(v => v.lang === 'zh-CN' && v.localService) ||
            voices.find(v => v.lang === 'zh-CN');

        if (voice) {
            console.log(`[TTS] -> VOICE CHOICE: ${voice.name}`);
            utterance.voice = voice;
        }

        utterance.onstart = () => {
            console.log(`[TTS] !!! ONSTART: Audio flowing for "${cleanText}" !!!`);
            if (onStart) onStart();
        };

        utterance.onend = () => {
            console.log(`[TTS] -> ONEND: Done with "${cleanText}"`);
            this.activeUtterance = null;
            if (onEnd) onEnd();
        };

        utterance.onerror = (e) => {
            if (e.error !== 'canceled') {
                console.error(`[TTS] -> ONERROR:`, e.error);
            }
            this.activeUtterance = null;
            if (onEnd) onEnd();
        };

        // 2. THE KICK + DELAY: 
        // We queue it, then wait a micro-moment before the resume-kick.
        this.synth.speak(utterance);

        // Triple-kick to ensure the OS audio buffer opens
        this.synth.pause();
        setTimeout(() => {
            this.synth.resume();
            console.log('[TTS] -> KICKED');
        }, 50);

        // Final diagnostic
        setTimeout(() => {
            if (!this.synth.speaking) {
                console.warn(`[TTS] -> WARNING: Synth claims IDLE after speak() for "${cleanText}"`);
            }
        }, 200);
    }

    stop() {
        if (this.synth) {
            this.synth.cancel();
            this.activeUtterance = null;
        }
    }
}

export const tts = new HanziTTS();
